module.exports = __webpack_public_path__ + "ci.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ci.svg
// module id = 490
// module chunks = 0